import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { createActivityLog, getLevelThreeFolder, moveFileToFolderThree } from '../core/_requests'
import { useAuth } from '../../auth'
import TextInput from '../../widgets/components/Input/TextInput'
import { Formik } from 'formik'
import { Form, Modal } from 'react-bootstrap'
import { CustomButton } from '../../widgets/components/UI/CustomButton'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import { getLocation } from '../../onboarding/core/_requests'

export const MoveToFolderModal = ({
  showMoveModal,
  setMoveShowModal,
  recordId,
  getFolderOrFileList,
  setSelectedPath,
  setSelectedFolderName
}: {
  showMoveModal: boolean
  setMoveShowModal: Dispatch<SetStateAction<boolean>>
  recordId: string | undefined
  id?: any
  getFolderOrFileList?: (
    folderLevel: string,
    folderId?: string,
    year?: number | null,
    quarter?: string | undefined | null,
    month?: string | undefined | null
  ) => void
  setSelectedPath?: any,
  setSelectedFolderName?: any
}) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [levelThreeFolderData, setLevelThreeFolderData] = useState<any>()
  const [, setLoading] = useState(false)
  const [moveLoading, setMoveLoading] = useState(false)

  const initialValues = {
    levelThreeId: '',
  }

  const fileSchema = Yup.object().shape({
    levelThreeId: Yup.string()
      .required(formatMessage({ id: 'Level Four Id is required' }))
      .nullable(),
  })
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }
  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: { success, errors },
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'MOVED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const onSubmit = async (values: any) => {
    if (!companyId) return
    if (!recordId) return
    try {
      setMoveLoading(true)
      const {
        data: { success, errors },
      } = await moveFileToFolderThree(companyId, recordId, values.levelThreeId)
      if (success) {
        setMoveShowModal(false)
        toast.success(`File moved successfully`)
        setSelectedFolderName('')
        setSelectedPath([])    
        createActivity(recordId)    
        if (getFolderOrFileList) {
          getFolderOrFileList('LevelOne')
        }
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setMoveLoading(false)
    }
  }
  const handleLevelThreeFolder = async () => {
    if (!companyId) return
    try {
      setLoading(true)
      const {
        data: { success, errors, data },
      } = await getLevelThreeFolder(companyId)
      if (success) {
        setLevelThreeFolderData(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleLevelThreeFolder()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      show={showMoveModal}
      onHide={() => setMoveShowModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>Move File</h2>
      </Modal.Header>
      <Formik initialValues={initialValues} validationSchema={fileSchema} onSubmit={onSubmit}>
        {(formik) => {
          return (
            <Form>
              <Modal.Body className='h-500px overflow-y-scroll'>
                {levelThreeFolderData?.map((item: { levelThreeId: string; name: string }) => (
                  <div>
                    <TextInput
                      fieldName={'levelThreeId'}
                      formik={formik}
                      customText={
                        <div className='d-flex justify-content-center align-items-center gap-2'>
                          <img src={folderIcon} width={30} height={30} alt={'folder'} />
                          <span className=''>{item.name}</span>
                        </div>
                      }
                      placeholder=''
                      fieldType={'radio'}
                      isCheckbox={true}
                      isWidthNotRequired={false}
                      margin='0'
                      isRadio={true}
                      value={item.levelThreeId}
                      isTooltipNotRequired
                      isMargin='1'
                    />
                  </div>
                ))}
              </Modal.Body>
              <Modal.Footer>
                <div className='d-flex flex-wrap gap-3'>
                  <BasicButton
                    buttonText={formatMessage({ id: 'Cancel' })}
                    border='none'
                    color='#F5F8FA'
                    textColor='#5E6278'
                    minWidth={90}
                    height='44px'
                    onClick={() => {
                      formik.resetForm()
                      setMoveShowModal(false)
                    }}
                  />

                  <CustomButton
                    isSubmitting={formik.isSubmitting}
                    isValid={formik.isValid}
                    buttonText={'Move File'}
                    loading={moveLoading}
                    height={44}
                    widthLoading={1}
                    width={1}
                    margin={'me-0'}
                    onSubmit={formik.handleSubmit}
                    marginButtom='0'
                  />
                </div>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}
